import { Plus, Trash2 } from 'lucide-react';
import { processarTextoMultiploItens } from '../utils/text-processor';
import { removerItemLista, adicionarMultiplosItensLista } from '../utils/lista-manager';
import { useI18n } from '@/contexts/i18n-hook';

interface AdequacoesAdministrativasSectionProps {
  adequacoesNormativas: string[];
  setAdequacoesNormativas: (adequacoes: string[]) => void;
  pendingAdequacao: string;
  setPendingAdequacao: (v: string) => void;
}

export function AdequacoesAdministrativasSection({
  adequacoesNormativas,
  setAdequacoesNormativas,
  pendingAdequacao,
  setPendingAdequacao,
}: AdequacoesAdministrativasSectionProps) {
  const { t } = useI18n();
  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900 mb-3">{t('apreciacaoModais.editarParte.adequacoesAdministrativas.titulo')}</h2>
      <div className="space-y-2">
        {adequacoesNormativas.map((item, index) => (
          <div key={index} className="flex items-start gap-2">
            <textarea
              ref={(el) => { if (el) { el.style.height = 'auto'; el.style.height = el.scrollHeight + 'px'; } }}
              rows={1}
              value={item}
              onChange={(e) => {
                const novaLista = [...adequacoesNormativas];
                novaLista[index] = e.target.value;
                setAdequacoesNormativas(novaLista);
              }}
              onInput={(e) => { e.currentTarget.style.height = 'auto'; e.currentTarget.style.height = e.currentTarget.scrollHeight + 'px'; }}
              style={{ resize: 'none', overflow: 'hidden' }}
              className="flex-1 border border-gray-300 rounded-md px-3 py-2 text-sm"
            />
            <button
              type="button"
              onClick={() => removerItemLista(adequacoesNormativas, setAdequacoesNormativas, index)}
              className="text-red-600 hover:text-red-800"
            >
              <Trash2 className="h-4 w-4" />
            </button>
          </div>
        ))}
        <div className="flex gap-2 mt-1">
          <textarea
            rows={1}
            value={pendingAdequacao}
            onChange={(e) => setPendingAdequacao(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                if (pendingAdequacao.trim()) {
                  setAdequacoesNormativas([...adequacoesNormativas, pendingAdequacao.trim()]);
                  setPendingAdequacao('');
                  e.currentTarget.style.height = 'auto';
                }
              }
            }}
            onPaste={(e) => {
              e.preventDefault();
              const textoColado = e.clipboardData.getData('text');
              const itensProcessados = processarTextoMultiploItens(textoColado);
              adicionarMultiplosItensLista(adequacoesNormativas, setAdequacoesNormativas, itensProcessados);
              setPendingAdequacao('');
              e.currentTarget.style.height = 'auto';
            }}
            onInput={(e) => { e.currentTarget.style.height = 'auto'; e.currentTarget.style.height = e.currentTarget.scrollHeight + 'px'; }}
            style={{ resize: 'none', overflow: 'hidden' }}
            placeholder={t('apreciacaoModais.editarParte.listaPlaceholder')}
            className="flex-1 border border-gray-300 rounded-md px-3 py-2 text-sm"
          />
          <button
            type="button"
            onClick={() => {
              if (pendingAdequacao.trim()) {
                setAdequacoesNormativas([...adequacoesNormativas, pendingAdequacao.trim()]);
                setPendingAdequacao('');
              }
            }}
            className="px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            <Plus className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}

